module.exports={"(optional)":"(optioneel)","(required)":"(vereist)"};